import ShowOutboxTypes from "./outbox.types";

const STORAGE_KEY = "gmail_sent_messages";

const loadSentMessages = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

const saveSentMessages = (messages) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(messages));
  } catch {
    // storage full or unavailable
  }
};

const INITIAL_STATE = {
  sentMessages: loadSentMessages(),
};

const outboxReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ShowOutboxTypes.SHOW_OUTBOX: {
      const updated = [action.payload, ...state.sentMessages];
      saveSentMessages(updated);
      return {
        ...state,
        sentMessages: updated,
      };
    }

    case ShowOutboxTypes.REMOVE_LAST_SENT: {
      const updated = state.sentMessages.slice(1);
      saveSentMessages(updated);
      return { ...state, sentMessages: updated };
    }

    default:
      return state;
  }
};

export default outboxReducer;
